import { GALLERY_ITEM_SOURCES } from '../../consts';

export default item => item?.source === GALLERY_ITEM_SOURCES.MEDIA_LIBRARY;
